import { applicationConfiguration } from 'app/modules/shared'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import React, { useContext } from 'react'
import SupademoTour from '../supademo-tour'
import AppbarDropdown from './appbar-dropdown'
import Button from 'app/modules/shared/components/button'

export function CustomButtons() {
  const { _t } = useTypedTranslation()
  const { extraButton, buildType, tutorialLinks } = useContext(applicationConfiguration)
  const text = extraButton?.text
  const link = extraButton?.link
  const isCommunity = buildType === 'community'

  const extraButtonActive = extraButton?.active

  if (extraButtonActive && (!text || !link)) {
    console.warn('Extra button is not configured correctly, both link and text should be set')
    return null
  }

  const extractSupademoId = (url: string): string | null => {
    const regex = /demo\/([^?]+)/
    const match = regex.exec(url)
    return match ? match[1] : null
  }

  const tourLinks = tutorialLinks.map((link) => {
    const supademoId = extractSupademoId(link.url)

    if (supademoId) {
      return <SupademoTour key={link.name} name={link.name} id={supademoId} />
    }

    return (
      <a
        key={link.name}
        className="dropdown-item d-flex align-items-center gap-x-2"
        href={link.url}
        target="_blank"
        rel="noreferrer"
      >
        <i className="ds3-icon ds3-external-link" />
        {link.name}
      </a>
    )
  })

  return (
    <>
      {isCommunity ? (
        <AppbarDropdown
          className="no-hover cursor-default hide-mobile"
          title={
            <Button id="appbar-start-tour" variant="secondary" className="capitalize gap-x-2 pe-2">
              {_t('start-tour')}
              <i className="ds3-icon ds3-chevron-down" />
            </Button>
          }
        >
          {tourLinks}
        </AppbarDropdown>
      ) : null}

      {extraButtonActive ? (
        <div className="appbar-item cursor-default hide-mobile">
          <a id="appbar-extra-link" className="btn btn-primary capitalize" href={link} target="_blank" rel="noreferrer">
            {text}
          </a>
        </div>
      ) : null}

      {extraButtonActive || isCommunity ? <div className="flex-divider h-9 my-auto hide-mobile" /> : null}
    </>
  )
}
